module.exports = __webpack_public_path__ + "img/sumary_total_co2.160563cd.svg";